module.exports = __webpack_public_path__ + "img/headshot.daed89ff.jpg";